import React from "react";
import { Tabs } from "@ann/web-components";
import { TabsContainer } from "./Tabs.styled";
import { RoleDetailsTabsEnum } from "../../enums/roleDetailsTabs";

const RoleDetailsTabs = ({ onTabChange, defaultIndex = RoleDetailsTabsEnum.OVERVIEW }) => {
  const handleTabChange = (index) => {
    if (onTabChange) {
      onTabChange(index);
    }
  };

  return (
    <TabsContainer>
      <Tabs defaultIndex={defaultIndex} size="medium" onChange={handleTabChange}>
        <Tabs.List>
          <Tabs.Tab iconLeft="short_text" index={RoleDetailsTabsEnum.OVERVIEW}>
            Overview
          </Tabs.Tab>
          <Tabs.Tab iconLeft="lock_open" index={RoleDetailsTabsEnum.PERMISSIONS}>
            Permissions
          </Tabs.Tab>
          <Tabs.Tab iconLeft="group" index={RoleDetailsTabsEnum.USERS}>
            Users
          </Tabs.Tab>
        </Tabs.List>
      </Tabs>
    </TabsContainer>
  );
};

export default RoleDetailsTabs;

